import React from "react";

export type StepErrorEntry = {
  label: string;
  message?: string;
};

type Props = {
  errors: Record<string, StepErrorEntry>;
  alertIconSvg?: string;
};

export const StepErrorAlert: React.FC<Props> = ({ errors, alertIconSvg }) => {
  const entries = Object.entries(errors);

  if (entries.length === 0) return null;

  const scrollToField = (id: string) => {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      setTimeout(() => {
        (el as HTMLElement).focus?.();
      }, 200);
    }
  };

  return (
    <div
      className="alert alert-danger vgr-form__form--alert grid g-col-12"
      role="alert"
      aria-live="polite"
      tabIndex={-1}
    >
      {alertIconSvg && (
        <div>
          <div dangerouslySetInnerHTML={{ __html: alertIconSvg }} />
        </div>
      )}

      <div className="g-col-10">
        <h2 className="alert-heading">
          Det finns fel i följande {entries.length} fält:
        </h2>

        <p>
          Klicka på ett fel nedan för att gå direkt till felaktiga fält i
          formuläret.
        </p>

        <ul>
          {entries.map(([id, { label, message }]) => (
            <li key={id}>
              <a
                href={`#${id}`}
                className="btn btn-link"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToField(id);
                }}
              >
                {label}
              </a>
              {message && <span> – {message}</span>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
